import { useEffect, useRef } from "react";

/**
 * Loads the Ratifi Claims SDK and initialises the form.
 * Scroll-to-form on step change is handled via the SDK's onStep callback.
 * The script is appended once per component mount and cleaned up on unmount.
 */
export function useRatifiSDK() {
  const sdkInitialized = useRef(false);

  useEffect(() => {
    if (sdkInitialized.current) return;
    sdkInitialized.current = true;

    const script = document.createElement("script");
    script.src = "https://link.bluelion-law.com/sdk/ratifi-claims.js";

    script.onload = () => {
      if (!window.RatifiClaims) return;

      window.RatifiClaims.init({
        campaignSlug: "bluelion-yoursolicitor",
        affiliateCode: "AFF-REV-105",
        containerId: "ratifi-claims-container",
        theme: {
          primaryColor: "#1c153a",
          buttonColor: "#1c153a",
        },
        onReady: function () { /* form mounted */ },
        onStep: function (step, name) { /* user advanced to step */ },
        onComplete: function (result) {
          console.log("Claim submitted:", result);
        },
        onError: function (error) {
          console.error("Error:", error);
        },
      });
    };

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []); // [] correct: sdkInitialized is a stable ref; all other vars are local to the effect
}
